import * as React from "react";
import {FormGroupProps} from "../../common/props/FormGroupProps";
import {PlaceholderProps} from "../../common/props/PlaceholderProps";
import {Option} from "ts-option";
import SelectBrand from "./component/SelectBrand";
import Brand from "../../../model/brand/Brand";
import FormGroup from "../../../hiberUiKit/src/molecules/FormGroup/FormGroup";
import {DisableableProps} from "../../common/props/DisableableProps";

type Props = FormGroupProps<string> & PlaceholderProps & DisableableProps;

/**
 * User brand form view group.
 */
export default class BrandFormGroup extends React.PureComponent <Props, {}> {
	constructor(props: Props) {
		super(props);
		this.onChange = this.onChange.bind(this);
	}

	render() {
		return (
			<FormGroup label={this.props.label} error={this.props.field.firstError().getOrElse("")}
					   customClass={"c-brand-select"}>
				<SelectBrand placeholder={this.props.placeholder}
							 selectedId={this.props.field.getOptionalValue()}
							 onChanged={this.onChange}
							 disabled={this.props.disabled}/>
			</FormGroup>
		);
	}

	/**
	 * Callback on changed brand.
	 * @param data
	 */
	onChange(data: Option<Brand>) {
		this.props.onChange(this.props.field.updateValue(data.map((b) => b.id)))
	}
}
